// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.AgGridTable_dashboard__nhpi0 {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.AgGridTable_dashboardContain__2TnNb {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_dashboardContain__2TnNb,
.AgGridTable_bodythemedark__depkQ .AgGridTable_dashboard__nhpi0,
.AgGridTable_bodythemedark__depkQ .AgGridTable_cont2__0qAUq {
  background-Color: #0f1824;
}

.AgGridTable_top_header__ou5bg .AgGridTable_top_header_inner__Wo0t1 {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.AgGridTable_cont2__0qAUq {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.AgGridTable_subLink__oSssK svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.AgGridTable_footer__gRNAd {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.AgGridTable_bodythemelight__Lpscx {
  background-color: #fff;
  padding-top: 90px;
}

.AgGridTable_bodythemedark__depkQ {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.AgGridTable_headerthemelight__BzUOG {
  background-color: #fff;
}

.AgGridTable_headerthemedark__Y9wlB {
  background-color: #132337;
}

.AgGridTable_top_header__ou5bg {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.AgGridTable_menuthemelight__KYb7S {
  background-color: #fff;
}

.AgGridTable_menuthemedark__XkWBc {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.AgGridTable_menulinklight__1iosI span {
  color: #666666 !important;
}

.AgGridTable_menulinklight__1iosI a {
  color: #CBCBCB !important;
}

.AgGridTable_menulinklight__1iosI:hover span, .AgGridTable_menulinklight__1iosI:hover a {
  color: #fff !important;
}

.AgGridTable_menulinkdarkSelected__HFQgg {
  background-color: #1c2e45;
  color: #3b82f6;
}

.AgGridTable_menuthemelight__KYb7S .AgGridTable_menulinklightSelected__BY-hc {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.AgGridTable_menulinkdark__jZijG {
  color: #92afd3 !important;
}

.AgGridTable_menulinklight__1iosI:hover {
  color: #fff !important;
  background-color: #131F43;
}

.AgGridTable_menulinklight__1iosI .AgGridTable_sub_arrow__Xa3\\+q svg path {
  stroke: #CBCBCB !important;
}

.AgGridTable_menulinklight__1iosI:hover .AgGridTable_sub_arrow__Xa3\\+q svg path {
  stroke: #fff !important;
}

.AgGridTable_menulinkdark__jZijG .AgGridTable_sub_arrow__Xa3\\+q svg path {
  stroke: #92afd3 !important;
}

.AgGridTable_menulinkdark__jZijG:hover .AgGridTable_sub_arrow__Xa3\\+q svg path {
  stroke: #fff !important;
}

.AgGridTable_menulinkdark__jZijG:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.AgGridTable_headinglight__J1miU {
  color: #60677e;
}

.AgGridTable_headingdark__9JLdm {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.AgGridTable_searchboxlight__CllIF {
  background-color: #fff;
  border: none;
}

.AgGridTable_searchboxdark__llMhu {
  background-color: #132337;
  color: #fff;
  border: none;
}

.AgGridTable_searchboxdark__llMhu::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.AgGridTable_tableheadlight__jpmUY {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.AgGridTable_tableheadlight__jpmUY th {
  color: #fff;
}

thead .AgGridTable_tableheadlight__jpmUY th:first-child,
thead .AgGridTable_tableheaddark__cdLpL th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .AgGridTable_tableheadlight__jpmUY th:last-child,
thead .AgGridTable_tableheaddark__cdLpL th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.AgGridTable_table__gzUk4.AgGridTable_table-borderless__EG-ua {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.AgGridTable_tableheaddark__cdLpL {
  background-color: #132337;
  color: #fff;
}

.AgGridTable_table-borderless__EG-ua tr:nth-child(even) {
  background-color: #F9FAFB;
}

.AgGridTable_table-borderless__EG-ua .AgGridTable_left-section__9eGgo {
  padding-top: 10px;
}

.AgGridTable_tablebodylight__Vd5yk td,
.AgGridTable_tablebodydark__MBhQ1 td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.AgGridTable_tablebodylight__Vd5yk {
  background-color: #fff;
}
.AgGridTable_tablebodylight__Vd5yk:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.AgGridTable_tablebodydark__MBhQ1 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.AgGridTable_tablebodydark__MBhQ1:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.AgGridTable_paginationlight__KwjSQ {
  color: #60677e !important;
  font-size: 13px !important;
}

.AgGridTable_paginationdark__oYOVY {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.AgGridTable_formthemelight__CDA8q {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.AgGridTable_formthemedark__sShrL {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.AgGridTable_formthemedark__sShrL ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.AgGridTable_viewformlight__bMDon {
  background-color: #f3f6f9;
}

.AgGridTable_permissionboxlight__PLV8h {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.AgGridTable_permissionboxdark__L7--1 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.AgGridTable_errormsgclr__pzUc4 {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.AgGridTable_graphclrlight__egSvo {
  background-color: #fff;
}

.AgGridTable_graphclrdark__E6Cwy {
  background-color: #132337;
}

/* 
Counter theme
*/
#AgGridTable_card1bglight__m9VSj {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#AgGridTable_card1bgdark__Ku3rM {
  background: #392f28;
}

#AgGridTable_card2bglight__c5izG {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#AgGridTable_card2bgdark__uYLDi {
  background: #1c3238;
}

#AgGridTable_card3bglight__MbQay {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#AgGridTable_card3bgdark__m2\\+EQ {
  background: #3a2434;
}

#AgGridTable_card4bglight__uMf15 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#AgGridTable_card4bgdark__-n5JW {
  background: #2f264f;
}

#AgGridTable_card1bgdark__Ku3rM a, #AgGridTable_card1bgdark__Ku3rM p,
#AgGridTable_card2bgdark__uYLDi a, #AgGridTable_card2bgdark__uYLDi p,
#AgGridTable_card3bgdark__m2\\+EQ a, #AgGridTable_card3bgdark__m2\\+EQ p,
#AgGridTable_card4bgdark__-n5JW a, #AgGridTable_card4bgdark__-n5JW p {
  color: #fff;
}

/* 
Action button theme
*/
.AgGridTable_actionbtnlight__naM\\+l {
  color: rgba(70, 71, 91, 0.8705882353);
}

.AgGridTable_actionbtnlight__naM\\+l:hover {
  cursor: pointer;
}

.AgGridTable_actionbtndark__OHyiS {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.AgGridTable_profiledropdownlight__4Psc1 {
  background-color: #fff;
}

.AgGridTable_profiledropdowndark__6IgD5 {
  background-color: #151521;
}

.AgGridTable_settingsection__LSgxf #AgGridTable_addform__kS3Ks.AgGridTable_formthemedark__sShrL .AgGridTable_savebtn__kRAGK {
  background-color: #3b82f6;
  color: #fff;
}

#AgGridTable_addform__kS3Ks.AgGridTable_formthemedark__sShrL .AgGridTable_savebtn__kRAGK {
  background-color: #3b82f6;
  color: #fff;
}

.AgGridTable_profile_conatiner__I3wT9 {
  border-radius: 5px !important;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_ag-theme-alpine__lPA4i .AgGridTable_ag-row__csi3R {
  background: #000 !important;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_formbtn__-JVon {
  background-color: #3b82f6;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_formbtn__-JVon:hover {
  background-color: #2563eb;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_resetbtn__o0M1p {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_resetbtn__o0M1p:hover {
  background-color: #3b82f6;
}

.AgGridTable_headingdark__9JLdm span {
  background-color: #132337;
}

.AgGridTable_resetbtn__o0M1p {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.AgGridTable_resetbtn__o0M1p:hover,
.AgGridTable_resetbtn__o0M1p:active,
.AgGridTable_resetbtn__o0M1p:focus {
  background-color: #131F43;
  color: #fff;
}

.AgGridTable_addBtn__EP8l6 {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.AgGridTable_addbtnlight__Z4LQS {
  background-color: #38A169;
}

.AgGridTable_addbtndark__rqhAG {
  background-color: #3b82f6;
}

.AgGridTable_addbtndark__rqhAG:hover {
  background-color: #2563eb;
}

.AgGridTable_formthemedark__sShrL label {
  color: #92afd3;
}

.AgGridTable_addBtn__EP8l6 svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.AgGridTable_addBtn__EP8l6:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.AgGridTable_cust_addBtn__pPFAI.AgGridTable_addBtn__EP8l6 svg {
  top: 2px;
}

.AgGridTable_deleteBtn__OpaEx {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.AgGridTable_deleteBtn__OpaEx {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.AgGridTable_deleteBtn__OpaEx:active, .AgGridTable_deleteBtn__OpaEx:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.AgGridTable_deleteBtn__OpaEx svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.AgGridTable_deleteBtn__OpaEx:hover,
.AgGridTable_deleteBtn__OpaEx:active,
.AgGridTable_deleteBtn__OpaEx:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.AgGridTable_confirmBtn__fAYts {
  background-color: #131F43;
}

.AgGridTable_confirmBtn__fAYts:hover,
.AgGridTable_confirmBtn__fAYts:active,
.AgGridTable_confirmBtn__fAYts:focus {
  background-color: #131F43;
}

.AgGridTable_confirmBtn__fAYts svg {
  top: 0;
}

.AgGridTable_delPopContainer__EFUeR .AgGridTable_modal-body__Z2FJV {
  padding: 25px;
  text-align: center;
}

.AgGridTable_delPopContainer__EFUeR .AgGridTable_delet_icon__PJ7Qj {
  margin-bottom: 11px;
}

.AgGridTable_delPopContainer__EFUeR p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.AgGridTable_arrowback__b7MqT svg {
  fill: #000;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_arrowback__b7MqT {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_arrowback__b7MqT svg {
  fill: #3b82f6;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_drpdwn_btn__ocus0 {
  background-color: #132337;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_empname__vjcTB {
  color: #92afd3 !important;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_navitemli__bXOLN a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_tabnavli__1fPnJ a.AgGridTable_settingsgeneral__TDGhc,
.AgGridTable_bodythemedark__depkQ .AgGridTable_tabnavli__1fPnJ a.AgGridTable_settingslinks__gRxiO:hover {
  background-color: #3b82f6;
  color: #fff;
}

.AgGridTable_bodythemedark__depkQ .AgGridTable_tabnavli__1fPnJ a.AgGridTable_settingslinks__gRxiO {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.AgGridTable_headerthemedark__Y9wlB .AgGridTable_dropdown_menu_contain__VYrmO {
  background-color: #1c2e45;
  color: #fff;
}

.AgGridTable_headerthemedark__Y9wlB .AgGridTable_dropdown_menu_contain__VYrmO ul li a,
.AgGridTable_headerthemedark__Y9wlB .AgGridTable_dropdown_menu_contain__VYrmO .AgGridTable_dropdown_item__bctu5,
.AgGridTable_headerthemedark__Y9wlB .AgGridTable_dropdown_menu_contain__VYrmO .AgGridTable_dropdown_item__bctu5 h5 {
  color: #fff;
}

.AgGridTable_headerthemedark__Y9wlB .AgGridTable_dropdown_menu_contain__VYrmO ul li a:hover,
.AgGridTable_headerthemedark__Y9wlB .AgGridTable_dropdown_menu_contain__VYrmO .AgGridTable_dropdown_item__bctu5:hover {
  background-color: #132337;
  color: #fff;
}

.AgGridTable_dropdown_item__bctu5:active {
  background-color: #F5F6FA;
}

.AgGridTable_profile_arrrow_dwn__vwoAg {
  stroke: #132337;
}

.AgGridTable_headerthemedark__Y9wlB .AgGridTable_profile_arrrow_dwn__vwoAg {
  stroke: #fff;
}

.AgGridTable_dateinputbox1__wz052 input,
.AgGridTable_dateinputbox1__wz052 span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .AgGridTable_tableheadlight__jpmUY th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .AgGridTable_dashboard__nhpi0 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .AgGridTable_cont2__0qAUq {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .AgGridTable_sectionright__Fn\\+g6 {
    float: unset !important;
  }
  .AgGridTable_dashboard__nhpi0 {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .AgGridTable_cont2__0qAUq {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .AgGridTable_bodythemelight__Lpscx, .AgGridTable_bodythemedark__depkQ {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .AgGridTable_exer_modal_contain__hBKwn .AgGridTable_modal-dialog__nlKqD {
    max-width: 1055px;
  }
  .AgGridTable_delPopContainer__EFUeR .AgGridTable_modal-dialog__nlKqD {
    max-width: 350px;
  }
}
#AgGridTable_tableheading__dXzk9 {
  font-size: 18px;
  margin-top: 20px;
}

.AgGridTable_sectionright__Fn\\+g6 {
  float: right;
}

.AgGridTable_tableaddbtn__Q-p14 {
  padding: 10px;
  min-width: 140px;
  border: none;
  background-color: #38A169;
  border-radius: 5px;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  margin-left: 10px;
}
.AgGridTable_tableaddbtn__Q-p14:hover {
  background-color: #207a4a;
}

#AgGridTable_actionbtn__x1G64 {
  border: none;
  margin-right: 10px;
  border-radius: 5px;
  background: none;
  font-weight: 100;
}

.AgGridTable_headercolorlight__PDNX0 {
  background-color: #131F43;
  color: #fff;
  text-overflow: initial !important;
}

.AgGridTable_headercolordark__yT-wv {
  background-color: #132337;
  color: #fff;
  text-overflow: initial !important;
}

#AgGridTable_searchboxpad__YyRyr {
  padding-right: 0px;
}

.AgGridTable_add_icon__7CcHq {
  margin-right: 5px;
  font-size: 20px;
  position: relative;
  top: 2px;
}

@media only screen and (max-width: 992px) {
  .AgGridTable_sectionright__Fn\\+g6 {
    float: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/AgTable/AgGridTable.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAmDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA3FO;EA4FP,2BAAA;EACA,gBAAA;ACzEF;;AD2EA;EACE,yBAAA;EACA,yBAjGO;EAkGP,kBAAA;ACxEF;;AD0EA;;;EAGE,yBAlEoB;ACLtB;;ADyEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACtEF;;ADyEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAzHO;EA0HP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACpEF;;AD0EA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACvEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBAjGY;ACwBd;;AD4EA;;CAAA;AAGA;EACE,sBAxGY;EAyGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAvHgB;EAwHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBApHY;AC4Cd;;AD2EA;EACE,yBAnIgB;AC2DlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAxIY;ACiEd;;ADyEA;EACE,yBAtJgB;ACgFlB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAvKsB;EAwKtB,cAlLkB;AC4GpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAlNc;AC6IhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBA3Nc;ACsJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBA1MsB;EA2MtB,WAlMY;AC6Hd;;ADwEA;;CAAA;AAGA;EACE,cAtMe;ACiIjB;;ADwEA;EACE,cA1Me;ACqIjB;;ADwEA;;CAAA;AAGA;EACE,sBApNY;EAqNZ,YAAA;ACrEF;;ADwEA;EACE,yBApOgB;EAqOhB,WA1NY;EA2NZ,YAAA;ACrEF;;ADuEA;EACE,cA3Ne;ACuJjB;;ADuEA;;CAAA;AAGA;EACE,yBAnRc;EAoRd,8BAAA;ACpEF;;ADsEA;EACE,WAzOY;ACsKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAvPkB;EAwPlB,WAhQY;ACkMd;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBA9QY;ACoNd;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cApRe;AC0NjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA/SY;EAgTZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBA5SkB;EA6SlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAtTa;AC6PjB;;AD8DA;;CAAA;AAGA;EACE,yBArUgB;AC0QlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBApVoB;EAqVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAxVY;AC8Rd;;AD6DA;EACE,yBApVkB;AC0RpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBArWY;AC0Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA9WY;ACmTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAvXY;AC4Td;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAhYY;ACqUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WA3YY;ACgVd;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cArZe;AC4VjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBAzbkB;EA0blB,WAzaY;AC+Wd;;AD4DA;EACE,yBA7bkB;EA8blB,WA7aY;ACoXd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBA1ckB;ACiZpB;;AD4DA;EACE,yBA7cwB;ACoZ1B;;AD4DA;EACE,WAjcY;EAkcZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAxdkB;AC+ZpB;;AD6DA;EACE,yBAvdgB;AC6ZlB;;AD6DA;EACE,eAAA;EACA,gBArgBc;EAsgBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAngBc;EAogBd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAzgBc;EA0gBd,WA5dY;ACmad;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WAleY;EAmeZ,yBA9fY;EA+fZ,YAAA;EACA,eAAA;EACA,gBA1hBc;ACiehB;;AD4DA;EACE,yBArgBY;AC4cd;;AD2DA;EACE,yBA9fkB;ACscpB;;AD0DA;EACE,yBAhgBwB;ACyc1B;;AD0DA;EACE,cAtgBiB;AC+cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA/fY;EAggBZ,yBA3hBY;EA4hBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA/hBW;EAgiBX,WA5gBY;EA6gBZ,eAAA;EACA,gBAlkBc;EAmkBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBAziBW;EA0iBX,WAthBY;EAuhBZ,eAAA;EACA,gBA5kBc;EA6kBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA/jBW;EAgkBX,WA5iBY;EA6iBZ,YAAA;ACxDF;;AD2DA;EACE,yBA/lBc;ACuiBhB;;AD2DA;;;EAGE,yBArmBc;AC6iBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCAnmBc;EAomBd,cAxmBkB;AC8iBpB;;AD6DA;EACE,aA5mBkB;ACkjBpB;;AD6DA;EACE,yBAxmBgB;AC8iBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAvmBY;AC6iBd;;AD6DA;;EAEE,yBA7nBkB;EA8nBlB,WA7mBY;ACmjBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlnBY;ACyjBd;;AD4DA;EACE,yBA/nBsB;EAgoBtB,WAvnBY;AC8jBd;;AD4DA;;;EAGE,WA7nBY;ACokBd;;AD4DA;;EAEE,yBA7oBgB;EA8oBhB,WAnoBY;AC0kBd;;AD4DA;EACE,yBAtrBO;AC6nBT;;AD4DA;EACE,eAtpBgB;AC6lBlB;;AD4DA;EACE,YA/oBY;ACslBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AA1sBA;EACE,eAAA;EAEA,gBAAA;AA2sBF;;AAxsBA;EACE,YAAA;AA2sBF;;AAxsBA;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,yBDoBU;ECnBV,kBAAA;EACA,WD6CU;EC5CV,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBDXY;ECYZ,iBAAA;AA2sBJ;AAzsBI;EACE,yBAAA;AA2sBN;;AAvsBA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA0sBF;;AAtsBA;EACE,yBDoCiB;ECnCjB,WDsBY;ECrBZ,iCAAA;AAysBF;;AAtsBA;EACE,yBDMgB;ECLhB,WDgBY;ECfZ,iCAAA;AAysBF;;AAtsBA;EACE,kBAAA;AAysBF;;AAtsBA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AAysBJ;;AAtsBA;EACE;IACE,WAAA;EAysBF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #DBEAFE;  \n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #D1FAE5;  \n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FEF3C7;  \n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #E9D5FF; \n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon1-color: #3B82F6;  \n$cardIcon2-color: #10B981;  \n$cardIcon3-color: #F59E0B;  \n$cardIcon4-color: #8B5CF6;  \n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n#tableheading{\n  font-size: 18px;\n   \n  margin-top: 20px;\n}\n\n.sectionright{\n  float: right;\n}\n\n.tableaddbtn{\n    padding: 10px;\n    min-width: 140px;\n    border: none;\n    background-color: $green-color;\n    border-radius: 5px;\n    color: $white-color; \n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 16px;\n    font-weight: $font-semiBold;\n    margin-left: 10px;\n\n    &:hover{\n      background-color: #207a4a;\n    }\n}\n\n#actionbtn{ \n  border: none;\n  margin-right: 10px;\n  border-radius: 5px;\n  background: none;\n  font-weight: 100;\n}\n\n\n.headercolorlight {\n  background-color: $primary-btncolor;\n  color: $white-color;\n  text-overflow: initial !important;\n  \n}\n.headercolordark {\n  background-color: $darkTheme_blue ; \n  color: $white-color;\n  text-overflow: initial !important;\n}\n\n#searchboxpad{\n  padding-right: 0px;\n}\n\n.add_icon{\n    margin-right: 5px;\n    font-size: 20px;\n    position: relative;\n    top: 2px;\n}\n\n@media only screen and (max-width: 992px) {\n  .sectionright{\n    float: left;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `AgGridTable_dashboard__nhpi0`,
	"dashboardContain": `AgGridTable_dashboardContain__2TnNb`,
	"bodythemedark": `AgGridTable_bodythemedark__depkQ`,
	"cont2": `AgGridTable_cont2__0qAUq`,
	"top_header": `AgGridTable_top_header__ou5bg`,
	"top_header_inner": `AgGridTable_top_header_inner__Wo0t1`,
	"subLink": `AgGridTable_subLink__oSssK`,
	"footer": `AgGridTable_footer__gRNAd`,
	"bodythemelight": `AgGridTable_bodythemelight__Lpscx`,
	"headerthemelight": `AgGridTable_headerthemelight__BzUOG`,
	"headerthemedark": `AgGridTable_headerthemedark__Y9wlB`,
	"menuthemelight": `AgGridTable_menuthemelight__KYb7S`,
	"menuthemedark": `AgGridTable_menuthemedark__XkWBc`,
	"menulinklight": `AgGridTable_menulinklight__1iosI`,
	"menulinkdarkSelected": `AgGridTable_menulinkdarkSelected__HFQgg`,
	"menulinklightSelected": `AgGridTable_menulinklightSelected__BY-hc`,
	"menulinkdark": `AgGridTable_menulinkdark__jZijG`,
	"sub_arrow": `AgGridTable_sub_arrow__Xa3+q`,
	"headinglight": `AgGridTable_headinglight__J1miU`,
	"headingdark": `AgGridTable_headingdark__9JLdm`,
	"searchboxlight": `AgGridTable_searchboxlight__CllIF`,
	"searchboxdark": `AgGridTable_searchboxdark__llMhu`,
	"tableheadlight": `AgGridTable_tableheadlight__jpmUY`,
	"tableheaddark": `AgGridTable_tableheaddark__cdLpL`,
	"table": `AgGridTable_table__gzUk4`,
	"table-borderless": `AgGridTable_table-borderless__EG-ua`,
	"left-section": `AgGridTable_left-section__9eGgo`,
	"tablebodylight": `AgGridTable_tablebodylight__Vd5yk`,
	"tablebodydark": `AgGridTable_tablebodydark__MBhQ1`,
	"paginationlight": `AgGridTable_paginationlight__KwjSQ`,
	"paginationdark": `AgGridTable_paginationdark__oYOVY`,
	"formthemelight": `AgGridTable_formthemelight__CDA8q`,
	"formthemedark": `AgGridTable_formthemedark__sShrL`,
	"viewformlight": `AgGridTable_viewformlight__bMDon`,
	"permissionboxlight": `AgGridTable_permissionboxlight__PLV8h`,
	"permissionboxdark": `AgGridTable_permissionboxdark__L7--1`,
	"errormsgclr": `AgGridTable_errormsgclr__pzUc4`,
	"graphclrlight": `AgGridTable_graphclrlight__egSvo`,
	"graphclrdark": `AgGridTable_graphclrdark__E6Cwy`,
	"card1bglight": `AgGridTable_card1bglight__m9VSj`,
	"card1bgdark": `AgGridTable_card1bgdark__Ku3rM`,
	"card2bglight": `AgGridTable_card2bglight__c5izG`,
	"card2bgdark": `AgGridTable_card2bgdark__uYLDi`,
	"card3bglight": `AgGridTable_card3bglight__MbQay`,
	"card3bgdark": `AgGridTable_card3bgdark__m2+EQ`,
	"card4bglight": `AgGridTable_card4bglight__uMf15`,
	"card4bgdark": `AgGridTable_card4bgdark__-n5JW`,
	"actionbtnlight": `AgGridTable_actionbtnlight__naM+l`,
	"actionbtndark": `AgGridTable_actionbtndark__OHyiS`,
	"profiledropdownlight": `AgGridTable_profiledropdownlight__4Psc1`,
	"profiledropdowndark": `AgGridTable_profiledropdowndark__6IgD5`,
	"settingsection": `AgGridTable_settingsection__LSgxf`,
	"addform": `AgGridTable_addform__kS3Ks`,
	"savebtn": `AgGridTable_savebtn__kRAGK`,
	"profile_conatiner": `AgGridTable_profile_conatiner__I3wT9`,
	"ag-theme-alpine": `AgGridTable_ag-theme-alpine__lPA4i`,
	"ag-row": `AgGridTable_ag-row__csi3R`,
	"formbtn": `AgGridTable_formbtn__-JVon`,
	"resetbtn": `AgGridTable_resetbtn__o0M1p`,
	"addBtn": `AgGridTable_addBtn__EP8l6`,
	"addbtnlight": `AgGridTable_addbtnlight__Z4LQS`,
	"addbtndark": `AgGridTable_addbtndark__rqhAG`,
	"cust_addBtn": `AgGridTable_cust_addBtn__pPFAI`,
	"deleteBtn": `AgGridTable_deleteBtn__OpaEx`,
	"confirmBtn": `AgGridTable_confirmBtn__fAYts`,
	"delPopContainer": `AgGridTable_delPopContainer__EFUeR`,
	"modal-body": `AgGridTable_modal-body__Z2FJV`,
	"delet_icon": `AgGridTable_delet_icon__PJ7Qj`,
	"arrowback": `AgGridTable_arrowback__b7MqT`,
	"drpdwn_btn": `AgGridTable_drpdwn_btn__ocus0`,
	"empname": `AgGridTable_empname__vjcTB`,
	"navitemli": `AgGridTable_navitemli__bXOLN`,
	"tabnavli": `AgGridTable_tabnavli__1fPnJ`,
	"settingsgeneral": `AgGridTable_settingsgeneral__TDGhc`,
	"settingslinks": `AgGridTable_settingslinks__gRxiO`,
	"dropdown_menu_contain": `AgGridTable_dropdown_menu_contain__VYrmO`,
	"dropdown_item": `AgGridTable_dropdown_item__bctu5`,
	"profile_arrrow_dwn": `AgGridTable_profile_arrrow_dwn__vwoAg`,
	"dateinputbox1": `AgGridTable_dateinputbox1__wz052`,
	"sectionright": `AgGridTable_sectionright__Fn+g6`,
	"exer_modal_contain": `AgGridTable_exer_modal_contain__hBKwn`,
	"modal-dialog": `AgGridTable_modal-dialog__nlKqD`,
	"tableheading": `AgGridTable_tableheading__dXzk9`,
	"tableaddbtn": `AgGridTable_tableaddbtn__Q-p14`,
	"actionbtn": `AgGridTable_actionbtn__x1G64`,
	"headercolorlight": `AgGridTable_headercolorlight__PDNX0`,
	"headercolordark": `AgGridTable_headercolordark__yT-wv`,
	"searchboxpad": `AgGridTable_searchboxpad__YyRyr`,
	"add_icon": `AgGridTable_add_icon__7CcHq`
};
export default ___CSS_LOADER_EXPORT___;
